import React from "react";
import { useTable } from "../../Components/useTable";

const DiamondsPackages = () => {
  const type = "Diamond Packages";
  const limitPerpage = 100;
  const pageRowslinit = [20 , 50 , 100];
  const headCells = [
    // { id: "appleId", numeric: false, label: "appleId" },
    { id: "amount", numeric: false, label: "Image" },
    { id: "diamond", numeric: false, label: "Diamond" },
    // { id: "productId", numeric: false, label: "Product Id" },
    // { id: "productName", numeric: false, label: "Product Name" },
    { id: "amount", numeric: false, label: "Discounted Amount" },
    { id: "original", numeric: false, label: "Original Amount" },
    // { id: "currency", numeric: false, label: "Currency" },
    // { id: "type", numeric: false, label: "type" },
    { id: "created", numeric: false, label: "Created At" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default DiamondsPackages;
